import { AbstractControl } from '@angular/forms';
import { isEmpty } from 'lodash';

import { DataSource } from '../services';

/**
 * update control value use selected text
 * find name with value in targetDataSource
 *
 * @param targetDataSource target data source
 * @param value selected value
 * @param targetFormControl target update form control
 * @param isUpdateWhenEmpty is still need update when text is empty
 */
const updateTextWithSelectedValue = (
  targetDataSource: DataSource,
  value: string,
  targetFormControl: AbstractControl,
  isUpdateWhenEmpty: boolean,
): void => {
  const text = targetDataSource.getItemTextByEntityId(value);

  if (isUpdateWhenEmpty || !isEmpty(text)) {
    targetFormControl?.setValue(text);
    targetFormControl?.markAsDirty();
  }
};

export { updateTextWithSelectedValue };
